module.exports = __webpack_public_path__ + "img/serve2.dba930f2.png";